// src/features/poster/services/posterService.ts

import api from '../../../api/axios';

import {
  POSTER_ENDPOINTS,
} from '../../../api';


export interface PosterPresignResponse {
  uploadUrl: string;
  imageUrl: string;
}


export interface Poster {
  posterId: number;
  imageUrl: string;
  createdAt: string;
}


/**
 * 포스터 Presigned URL 발급
 *
 * SUPERADMIN
 */
export const getPosterPresignUrl =
  async (
    filename: string,
    contentType: string,
  ): Promise<PosterPresignResponse> => {
    const response =
      await api.post(
        POSTER_ENDPOINTS
          .SUPERADMIN
          .PRESIGN,
        {
          filename,
          contentType,
        },
      );

    return response.data.data;
  };


/**
 * 포스터 생성
 *
 * SUPERADMIN
 */
export const createPoster =
  async (
    imageUrl: string,
  ): Promise<void> => {
    await api.post(
      POSTER_ENDPOINTS
        .SUPERADMIN
        .CREATE,
      {
        imageUrl,
      },
    );
  };


/**
 * 포스터 목록 조회
 *
 * SUPERADMIN
 */
export const fetchPosters =
  async (): Promise<Poster[]> => {
    const response =
      await api.get(
        POSTER_ENDPOINTS
          .SUPERADMIN
          .LIST,
      );

    return (
      response.data.data ??
      []
    );
  };


/**
 * 포스터 삭제
 *
 * SUPERADMIN
 */
export const deletePoster =
  async (
    posterId: number,
  ): Promise<void> => {
    await api.delete(
      POSTER_ENDPOINTS
        .SUPERADMIN
        .DELETE(
          posterId,
        ),
    );
  };